import { useNavigate } from 'react-router-dom'

import { Logotipo } from '../usuario/Logotipo'

import BtnSaldo from '../usuario/BtnSaldo'
import { useContext, useEffect, useState, useRef } from 'react'
import { ContextoGeral } from '../../contextos/ContextoGeral'

import logotipoMapp from './../../assets/logo-mapp.png'
import { abrirLinkNoNavegador, print } from '../../servicos/Uteis'
import { Drawer } from '@mui/material'
import API from '../../servicos/API.jsx'
import AppAPI from '../../servicos/AppAPI'
import ServicoAPI from '../../servicos/ServicoAPI'
import { FaTrophy, FaWhatsapp } from 'react-icons/fa'
import { exibeMenuPremios } from './menuPremiosDominio'
import { indicacaoModuloDisponivel } from '../../utils/indicacaoModulo'
import { relatorioMenuDisponivel } from '../../utils/relatorioModulo'
import { resolverRotulosGestaoVaga } from '../../paginas/App/gestaoVaga/gestaoVagaRotuloUtil'
import styles from './Menu.module.css'

const GESTAO_VAGAS_MENU_VAZIO = { ativo: false, quantidade: 0, info: null }

export default function MenuLateral(props) {
	const { dados, centralAjuda, setCentralAjuda, gestaoVagasModulo } = useContext(ContextoGeral)

	const [menuItems, setMenuItems] = useState([])
	const centralAjudaCarregado = useRef(false)
	const [exibirMenuKm, setExibirMenuKm] = useState(false)
	// Vem do ContextoGeral: carregado uma vez por sessão, não a cada troca de página.
	const gestaoVagasMenu = gestaoVagasModulo ?? GESTAO_VAGAS_MENU_VAZIO
	const [exibirMenuRelatorio, setExibirMenuRelatorio] = useState(true)
	const [exibirMenuCampanhas, setExibirMenuCampanhas] = useState(false)

	const navigate = useNavigate()

	const URL_PREMIOS = 'https://www.promocaodasquebradas.com.br/'
	const URL_GUINCHO = 'https://wa.me/5511921462013'

	useEffect(() => {
		const itensBase = [
			{
				rota: '/app/home',
				titulo: 'Inicio',
				ativo: true
			},
			{
				rota: '/app/testarStatus',
				titulo: 'Testar Status',
				ativo: true
			},
			{
				rota: '/app/indicarCliente',
				titulo: 'Indique um cliente',
				moduloIndicacao: true,
				ativo: true
			},
			{
				rota: '/app/indicarCliente/relatorio',
				titulo: 'Relatório de indicações',
				moduloIndicacao: true,
				ativo: true
			},
		]

		if (exibeMenuPremios(dados?.dominio)) {
			itensBase.push({
				titulo: 'PRÊMIOS',
				ativo: true,
				urlExterna: URL_PREMIOS,
				destaque: true
			})
			itensBase.push({
				titulo: 'Chamar Guincho',
				ativo: true,
				urlExterna: URL_GUINCHO,
				destaque: true,
				icone: 'guincho'
			})
		}

		if (exibirMenuRelatorio) {
			itensBase.push({
				rota: '/app/relatorios',
				titulo: 'Relatórios',
				ativo: true
			})
		}

		if (exibirMenuCampanhas) {
			itensBase.push({
				rota: '/app/campanhas',
				titulo: 'Metas',
				ativo: true
			})
		}

		itensBase.push(
			{
				rota: '/app/dadosUsuario',
				titulo: 'Dados adicionais',
				ativo: true
			},
			{
				rota: '/app/configuracoes',
				titulo: 'Configurações',
				ativo: true
			},
			{
				rota: '/app/politicaPrivacidade',
				titulo: 'Política de privacidade',
				ativo: true
			}
		)

		let arr = itensBase.map((item, index) => ({ ...item, index }))

		if (gestaoVagasMenu.ativo) {
			const qtd = gestaoVagasMenu.quantidade
			// Rótulo configurado no painel (por tenant); fallback ao texto padrão.
			const rotuloCustom = String(gestaoVagasMenu.info?.rotuloMenu ?? '').trim()
			const rotulos = resolverRotulosGestaoVaga(rotuloCustom || undefined)
			const rotuloBase = rotuloCustom || (qtd === 1 ? rotulos.singular : rotulos.plural)
			const tituloGestao = qtd > 0 ? `${rotuloBase} (${qtd})` : rotuloBase
			const idxRelatorios = arr.findIndex((i) => i.rota === '/app/relatorios')
			const itemGestao = {
				rota: '/app/gestaoVaga',
				titulo: tituloGestao,
				ativo: true,
				moduloInfo: gestaoVagasMenu.info
			}
			if (idxRelatorios >= 0) {
				arr.splice(idxRelatorios + 1, 0, itemGestao)
			} else {
				arr.push(itemGestao)
			}
		}

		arr = arr.map((item, index) => ({ ...item, index }))

		let proximoIndice = arr.length
		// Adiciona Central de Ajuda apenas se centralAjuda.resultado for true
		if (centralAjuda?.resultado === true) {
			arr.push({
				index: proximoIndice++,
				rota: '/app/centralAjuda',
				titulo: 'Central de Ajuda',
				ativo: true
			})
		}

		if (exibirMenuKm) {
			arr.push({
				index: proximoIndice++,
				rota: '/app/registroJornadaKm',
				titulo: 'Registro jornada (KM)',
				ativo: true
			})
		}

		if (dados.modulos != null && !indicacaoModuloDisponivel(dados)) {
			arr = arr.filter((item) => !item.moduloIndicacao)
		}

		setMenuItems(arr)
	}, [centralAjuda, dados?.dominio, dados.modulos, dados?.config?.indicar, exibirMenuCampanhas, exibirMenuKm, exibirMenuRelatorio, gestaoVagasMenu])

	useEffect(() => {
		async function checarRelatorio() {
			if (!dados?.dominio || !dados?.idProf || !dados?.token) {
				setExibirMenuRelatorio(true)
				return
			}
			try {
				const resposta = await AppAPI.buscarConfigRelatorio(dados)
				setExibirMenuRelatorio(relatorioMenuDisponivel(resposta))
			} catch {
				setExibirMenuRelatorio(true)
			}
		}
		checarRelatorio()
	}, [dados?.dominio, dados?.idProf, dados?.token])

	useEffect(() => {
		let cancelado = false

		async function checarCampanhas() {
			if (!dados?.dominio || !dados?.idProf || !dados?.token) {
				setExibirMenuCampanhas(false)
				return
			}

			try {
				const resposta = await ServicoAPI.campanhasBonificacaoModuloAtivo(dados)
				if (!cancelado) {
					setExibirMenuCampanhas(
						resposta?.resultado === true && resposta?.dados?.ativoModulo === true
					)
				}
			} catch {
				if (!cancelado) setExibirMenuCampanhas(false)
			}
		}

		checarCampanhas()
		return () => {
			cancelado = true
		}
	}, [dados?.dominio, dados?.idProf, dados?.token])

	useEffect(() => {
		async function checarKm() {
			if (!dados?.dominio || !dados?.idProf || !dados?.token) {
				setExibirMenuKm(false)
				return
			}
			try {
				const r = await ServicoAPI.kmJornadaConfig(dados)
				const exibir = !!r?.resultado && !!r?.dados?.ativoModulo
				setExibirMenuKm(exibir)
			} catch (err) {
				setExibirMenuKm(false)
			}
		}
		checarKm()
	}, [dados?.dominio, dados?.idProf, dados?.token])

	useEffect(() => {
		async function buscarCentralAjuda() {
			const idProf = dados?.idProf
			const dominio = dados?.dominio
			if (dominio && idProf && !centralAjudaCarregado.current) {
				centralAjudaCarregado.current = true
				try {
					const resposta = await API.post("/appProfissional/acessar", {
						dominio: dados.dominio,
						rota: "/suporte/centralAjuda",
						params: {
							idProf: dados.idProf
						},
						method: "GET",
						metodo: "GET",
						cabecalho: {
							token: dados.token
						}
					})
					
					console.log("Resposta da Central de Ajuda:", resposta.data)
					setCentralAjuda(resposta.data)
				} catch (error) {
					console.error("Erro ao buscar central de ajuda:", error)
					setCentralAjuda(null)
				}
			}
		}

		buscarCentralAjuda()
	}, [dados?.idProf, dados?.dominio, setCentralAjuda])

	// Removido console.log que causava ruído e re-renders

	return <Drawer
		sx={{
			'& .MuiDrawer-paper': {
				width: '75vw',
				maxWidth: '100%',
				paddingTop: 'var(--safe-top, 0px)',
			},
		}}
		anchor="right"
		open={props.show}
		onClose={() => props.setShow(false)}
	>
		<div>
			<div>
				<div style={{ flex: 1 }}>
					<Logotipo aux={() => props.setShow(false)} />
					<BtnSaldo />
				</div>
			</div>
			<div
				className=''
				style={{
					height: '',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between'
				}}
			>
				<div className="nav px-2 flex-col nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
					{menuItems.filter((item) => !(item.moduloIndicacao && !indicacaoModuloDisponivel(dados))).map((item, id) => {
						const itemKey = `menu-${id}-${item.rota || item.urlExterna || item.titulo || 'item'}`

						const onClickItem = async () => {
							if (!item.ativo) {
								print("Você não possui este módulo!")
								return
							}

							if (item.rota === '/app/gestaoVaga') {
								props.setShow(false)
								const info = item.moduloInfo ?? gestaoVagasMenu.info
								if (info?.ativoModulo) {
									navigate(item.rota, { state: { moduloInfo: info } })
								} else {
									print("Gestão de vagas não está disponível no momento.")
								}
								return
							}

							props.setShow(false)
							if (item.urlExterna) {
								abrirLinkNoNavegador(item.urlExterna)
							} else {
								navigate(item.rota)
							}
						}

						if (item.destaque) {
							const ehGuincho = item.icone === 'guincho'
							const IconeDestaque = ehGuincho ? FaWhatsapp : FaTrophy
							return (
								<button
									key={itemKey}
									type="button"
									className={ehGuincho ? `${styles.itemPremios} ${styles.itemGuincho}` : styles.itemPremios}
									onClick={onClickItem}
								>
									<IconeDestaque className={ehGuincho ? styles.itemGuinchoIcone : styles.itemPremiosIcone} aria-hidden />
									<span>{item.titulo}</span>
								</button>
							)
						}

						let classe = "rounded p-2 text-start my-0 w-full font-normal"
						const itemAtivo = props.ativoRota
							? item.rota === props.ativoRota
							: props.ativo == item.index
						if (itemAtivo) {
							classe = "rounded p-2 text-start w-full text-white font-normal active"
						}

						return <div
							key={itemKey}
							className={classe}
							id={`v-pills-home-tab-${id}`}
							data-bs-toggle="pill"
							data-bs-target="#v-pills-home"
							type="button"
							role="tab"
							style={{
								backgroundColor: itemAtivo ? "var(--primaria)" : "none",
								color: itemAtivo ? "" : "var(--primaria)"
							}}
							aria-controls="v-pills-home"
							aria-selected="true"
							onClick={onClickItem}
						>
							{item.titulo}
						</div>
					})}
				</div>
				{dados.config?.exibicao ? (
					<div
						className='p-3 flex flex-col'
						onClick={() => {
							if (!!window.AndroidInterface) {
								if (typeof window.AndroidInterface.redirectLink === "function") {
									window.AndroidInterface.redirectLink('https://mappsistemas.com.br/')
								}
							}
						}}
					>
						<small className='small'>
							<small>
								Desenvolvido por:
							</small>
						</small>
						<img style={{ paddingBottom: '0.5rem', width: '40%' }} alt="" src={logotipoMapp} />
					</div>
				) : ('')}
				<div className='flex w-full pe-3 mt-3 sticky justify-end' style={{
					bottom: '1.5rem',
				}}>
					<button onClick={() => { props.setShow(false) }} className='btn-close p-3'>
						{/* <Close color='error' /> */}
					</button>
				</div>
			</div>
		</div>
	</Drawer>
}
